export default "__VITE_ASSET__C5l6eXHG__"